'use strict';

var HSE_CONSTANTS = {
  MARKETS_PER_REQUEST: 200
};
module.exports = HSE_CONSTANTS;